import { render } from "./TopBrands.vue?vue&type=template&id=2b780f01&scoped=true"
import script from "./TopBrands.vue?vue&type=script&lang=js"
export * from "./TopBrands.vue?vue&type=script&lang=js"

import "./TopBrands.vue?vue&type=style&index=0&id=2b780f01&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b780f01"],['__file',"src/components/TopBrands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b780f01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b780f01', __exports__)) {
    console.log('reload')
    api.reload('2b780f01', __exports__)
  }
  
  module.hot.accept("./TopBrands.vue?vue&type=template&id=2b780f01&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b780f01', render)
  })

}


export default __exports__